import actions from './actions';
const initState = {
    singleRechargeLoading: false,
    singleRechargeMessage: null,
    singleRechargeError: null,

    bulkRechargeFData: [],
    bulkRechargeLoading: false,
    bulkRechargeMessage: null,
    bulkRechargeError: null,

}

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.SINGLE_RECHARGE:
            return {
                ...state,
                singleRechargeLoading: true,
                singleRechargeMessage: null,
                singleRechargeError: null,
            };
        case actions.SINGLE_RECHARGE_SUCCESS:
            return {
                ...state,
                singleRechargeLoading: false,
                singleRechargeMessage: action.payload.message,
                singleRechargeError: null,
            };
        case actions.SINGLE_RECHARGE_FAILED:
            return {
                ...state,
                singleRechargeLoading: false,
                singleRechargeMessage: null,
                singleRechargeError: action.payload.error,

            };

        case actions.BULK_RECHARGE:
            return {
                ...state,
                bulkRechargeFData: [],
                bulkRechargeLoading: true,
                bulkRechargeMessage: null,
                bulkRechargeError: null,
            };
        case actions.BULK_RECHARGE_SUCCESS:
            return {
                ...state,
                bulkRechargeLoading: false,
                bulkRechargeMessage: action.payload.message,
                bulkRechargeError: null,
                bulkRechargeFData: []
            };
        case actions.BULK_RECHARGE_FAILED:
            return {
                ...state,
                bulkRechargeLoading: false,
                bulkRechargeMessage: null,
                bulkRechargeFData: action.payload.fdata,
                bulkRechargeError: action.payload.error,

            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                singleRechargeMessage: null,
                singleRechargeError: null,
                bulkRechargeFData: [],
                bulkRechargeMessage: null,
                bulkRechargeError: null,
            };



        default:
            return state;
    }
}